import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "294",
  "slug": "spot-greece-from-satellite-imagery",
  "title": "How to Recognise Greece in Satellite Images",
  "excerpt": "Greece has a deeply indented mainland coast and many islands in the Aegean and Ionian seas.",
  "date": "2026-04-25",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/greece.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Greece has a deeply indented mainland coast and many islands in the Aegean and Ionian seas. The Peloponnese has a distinctive set of southward-pointing peninsulas, while Crete stretches east-west farther south. Mountains occupy much of the mainland interior."
    },
    {
      "type": "heading",
      "text": "Mountains and the Aegean islands"
    },
    {
      "type": "paragraph",
      "text": "Trace the Peloponnese and find the narrow connection near Corinth. Compare its coastline with Crete at the same scale."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Dry slopes and coastal settlements also occur in Turkey and Italy. White buildings and possible olive groves cannot establish Greece on their own. Start with the arrangement of islands and peninsulas, then examine smaller features."
    }
  ],
  "imageAlt": "Greece regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
